import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Eye } from 'lucide-react';

const RecentViewProducts = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasProducts, setHasProducts] = useState(false);

    useEffect(() => {
        const loadProductsFromStorage = () => {
            try {
                setLoading(true);
                // Get recently viewed products from localStorage
                const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
                
                if (recentlyViewed.length > 0) {
                    setProducts(recentlyViewed);
                    setHasProducts(true);
                } else {
                    setHasProducts(false);
                }
            } catch (error) {
                console.error('Error reading from localStorage:', error);
                setHasProducts(false);
            } finally {
                setLoading(false);
            }
        };

        loadProductsFromStorage();
        
        // Listen for storage changes to update the component when new products are viewed
        const handleStorageChange = (e) => {
            if (e.key === 'recentlyViewed') {
                loadProductsFromStorage();
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const ProductCard = ({ product }) => (
        <article className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
            <div className="service-card bg-white aos-init" data-aos-easing="linear">
                <div className="position-relative">
                    <Link to={`/${product.slug}/${product.productId}`}>
                        <img
                            src={product.image}
                            className="recently-view-card-img w-100 d-none d-xl-block"
                            width={293}
                            height={160}
                            alt={product.name}
                            style={{ objectFit: 'cover' }}
                        />
                    </Link>
                    <Link to={`/${product.slug}/${product.productId}`}>
                        <img
                            src={product.image}
                            className="recently-view-card-img w-100 d-block d-xl-none"
                            style={{ aspectRatio: '16 / 9', objectFit: 'cover' }}
                            alt={product.name}
                        />
                    </Link>
                </div>

                <div className="service-card-content">
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <h3 className="service-card-price fw-bold">${product.price}</h3>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                            <Eye size={16} />
                            <span className="service-card-rating">
                                Recently Viewed
                            </span>
                        </div>
                    </div>
                    <h3 className="service-card-title fw-semibold">
                        <Link to={`/${product.slug}/${product.productId}`}>
                            {product.name}
                        </Link>
                    </h3>
                    <div className="d-flex align-items-center service-card-author">
                        <span className="text-muted small">
                            Category: {product.category}
                        </span>
                    </div>
                </div>
            </div>
        </article>
    );

    // Don't render the component if there are no products after loading
    if (!loading && !hasProducts) {
        return null;
    }

    return (
        <section className="recently-view pb-110 bg-custom py-110">
            <div className="container">
                <div className="row justify-content-between align-items-end mb-40">
                    <div className="col-auto">
                        <h2 className="fw-bold section-title">Recently Viewed Products</h2>
                        <p className="section-desc">Products You've Recently Explored</p>
                    </div>
                </div>
                <div className="position-relative">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            {products.map((product) => (
                                <ProductCard key={product.productId} product={product} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default RecentViewProducts;